module.exports = __webpack_public_path__ + "media/nb_no_s2_Annemari.02bf3238.oga";